import * as types from './mutation-types'

export const loadUsersGroups = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/groups/collection', data).then((response) => {
            commit(types.LOAD_USERS_GROUPS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createUserGroup = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/group', data).then((response) => {
            commit(types.ADD_USER_GROUP, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateUserGroup = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/${data.id}/group`, data).then((response) => {
            commit(types.UPDATE_USER_GROUP, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteUserGroup = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/${id}/group`).then((response) => {
            commit(types.DELETE_USER_GROUP, id)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addUsersToGroup = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('set/users/to/group', data).then((response) => {
            commit(types.UPDATE_USER_GROUP, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const removeUsersFromGroup = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('unset/users/to/group', data).then((response) => {
            commit(types.UPDATE_USER_GROUP, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

